"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = void 0;
var react_1 = __importStar(require("react"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var nextId = 0;
var emitToast = null;
function toast(p) {
    emitToast === null || emitToast === void 0 ? void 0 : emitToast(p);
}
exports.toast = toast;
function Toast() {
    var _a = (0, react_1.useState)([]), items = _a[0], setItems = _a[1];
    var timers = (0, react_1.useRef)(new Map());
    (0, react_1.useEffect)(function () {
        emitToast = function (p) {
            var _a;
            var id = ++nextId;
            setItems(function (prev) { return __spreadArray(__spreadArray([], prev, true), [__assign(__assign({}, p), { id: id })], false); });
            var t = setTimeout(function () {
                timers.current.delete(id);
                setItems(function (prev) { return prev.filter(function (item) { return item.id !== id; }); });
            }, (_a = p.autoHideMs) !== null && _a !== void 0 ? _a : 2500);
            timers.current.set(id, t);
        };
        return function () {
            emitToast = null;
        };
    }, []);
    var dismiss = function (id) {
        var t = timers.current.get(id);
        if (t !== undefined) {
            clearTimeout(t);
            timers.current.delete(id);
        }
        setItems(function (prev) { return prev.filter(function (item) { return item.id !== id; }); });
    };
    if (items.length === 0)
        return null;
    return (react_1.default.createElement(Box_1.default, { sx: {
            position: "fixed",
            top: 16,
            right: 16,
            zIndex: 1400,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxWidth: 400,
            pointerEvents: "none",
        } }, items.map(function (item) {
        var _a;
        return (react_1.default.createElement(Alert_1.default, { key: item.id, onClose: function () { return dismiss(item.id); }, severity: (_a = item.severity) !== null && _a !== void 0 ? _a : "success", variant: "filled", sx: __assign({ pointerEvents: "auto" }, item.sx) }, item.message));
    })));
}
exports.default = Toast;
